export const VEHICLE_DELIVERY = "VEHICLE_DELIVERY";
export const VEHICLE_REPLACEMENT = "VEHICLE_REPLACEMENT";
export const TRANSFER_RATE = "TRANSFER_RATE";
export const DAMAGE_SHEET_RATE = "DAMAGE_SHEET_RATE";